import { userLoginMutation } from "../../../../api/backend/account/login/api"
import { LoginError } from "../../../../api/backend/backend-api"
import { AppThunk } from "../../../../state/store"
import { loadAuthenticatedProfile } from "../../../user/actions"
import { saveAuthToken } from "../../services/authService"
import {
  userLoginStart,
  userLoginWrongCredentials,
  userLoginSuccessful,
  userLoginFailure,
  userLoginOldUser,
} from "./loginSlice"
import { LoginResult, UserLoginInput } from "./loginTypes"

const updateLoginState = (
  loginAction: () => Promise<LoginResult>,
  callback?: () => void
): AppThunk => async (dispatch) => {
  try {
    dispatch(userLoginStart())
    const { token, wrongCredentials, oldUser } = await loginAction()
    if (oldUser) {
      dispatch(userLoginOldUser())
      return
    }
    if (wrongCredentials) {
      dispatch(userLoginWrongCredentials())
      return
    }
    saveAuthToken(token)
    dispatch(loadAuthenticatedProfile())
    dispatch(userLoginSuccessful())
    if (callback) {
      callback()
    }
  } catch (e) {
    dispatch(userLoginFailure())
  }
}

export const login = (input: UserLoginInput, callback?: () => void) => {
  return updateLoginState(async () => {
    const result = await userLoginMutation({
      email: input.username,
      password: input.password,
      passwordResetBaseUrl: input.pwdResetBaseUrl,
    })
    return {
      token: result.data?.login.accessToken,
      oldUser: result.data?.login.errorType === LoginError.OldUser,
      wrongCredentials:
        (result.errors?.length ?? 0) > 0 || result.data?.login.errorType,
    } as LoginResult
  }, callback)
}

// export const socialLogin = (input: SocialLoginInput, redirectUrl?: string) => {
//   return updateLoginState(
//     async () => {
//       const result = await userSocialLoginMutation(
//         input.accessToken,
//         input.provider
//       )
//       return {
//         token: result.data?.socialAuth?.token,
//         wrongCredentials: (result.errors?.length ?? 0) > 0,
//       } as LoginResult
//     },
//     () => (redirectUrl ? router.push(redirectUrl) : undefined)
//   )
// }
